webpackJsonp([35884836353623],{

/***/ 305:
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict'; // eslint-disable-line strict
	
	/**
	 * Traverses properties on objects and arrays. If an intermediate property is
	 * either null or undefined, it is instead returned. The purpose of this method
	 * is to simplify extracting properties from a chain of maybe-typed properties.
	 *
	 * === EXAMPLE ===
	 *
	 * Consider the following type:
	 *
	 *   const props: {
	 *     user: ?{
	 *       name: string,
	 *       friends: ?Array<User>,
	 *     }
	 *   };
	 *
	 * Getting to the friends of my first friend would resemble:
	 *
	 *   props.user &&
	 *   props.user.friends &&
	 *   props.user.friends[0] &&
	 *   props.user.friends[0].friends
	 *
	 * Instead, `idx` allows us to safely write:
	 *
	 *   idx(props, _ => _.user.friends[0].friends)
	 *
	 * The second argument must be a function that returns one or more nested member
	 * expressions. Any other expression has undefined behavior.
	 *
	 * === NOTE ===
	 *
	 * The code below exists for the purpose of illustrating expected behavior and
	 * is not meant to be executed. The `idx` function is used in conjunction with a
	 * Babel transform that replaces it with better performing code:
	 *
	 *   props.user == null ? props.user :
	 *   props.user.friends == null ? props.user.friends :
	 *   props.user.friends[0] == null ? props.user.friends[0] :
	 *   props.user.friends[0].friends
	 *
	 * All this machinery exists due to the fact that an existential operator does
	 * not currently exist in JavaScript.
	 */
	
	function idx(input, accessor) {
	  try {
	    return accessor(input);
	  } catch (error) {
	    if (error instanceof TypeError) {
	      if (nullPattern.test(error)) {
	        return null;
	      } else if (undefinedPattern.test(error)) {
	        return undefined;
	      }
	    }
	    throw error;
	  }
	}
	
	/**
	 * Some actual error messages for null:
	 *
	 * TypeError: Cannot read property 'bar' of null
	 * TypeError: Cannot convert null value to object
	 * TypeError: foo is null
	 * TypeError: null has no properties
	 * TypeError: null is not an object (evaluating 'foo.bar')
	 * TypeError: null is not an object (evaluating '(" undefined ", null).bar')
	 */
	var nullPattern = /^null | null$|^[^(]* null /;
	var undefinedPattern = /^undefined | undefined$|^[^(]* undefined /;
	
	idx.default = idx;
	module.exports = idx;


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(322)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./react-swipe'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.reactSwipe);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _reactSwipe) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _reactSwipe2.default;
	});

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes);
	    global.reactSwipe = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var supportsCaptureOption = false;
	  function setHasSupportToCaptureOption(hasSupport) {
	    supportsCaptureOption = hasSupport;
	  }
	
	  try {
	    addEventListener("test", null, Object.defineProperty({}, 'capture', { get: function get() {
	        setHasSupportToCaptureOption(true);
	      } }));
	  } catch (e) {}
	
	  function getSafeEventHandlerOpts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };
	
	    return supportsCaptureOption ? options : options.capture;
	  }
	
	  /**
	   * [getPosition returns a position element that works for mouse or touch events]
	   * @param  {[Event]} event [the received event]
	   * @return {[Object]}      [x and y coords]
	   */
	  function getPosition(event) {
	    if ('touches' in event) {
	      var _event$touches$ = event.touches[0],
	          pageX = _event$touches$.pageX,
	          pageY = _event$touches$.pageY;
	
	      return { x: pageX, y: pageY };
	    }
	
	    var screenX = event.screenX,
	        screenY = event.screenY;
	
	    return { x: screenX, y: screenY };
	  }
	
	  var ReactSwipe = function (_Component) {
	    _inherits(ReactSwipe, _Component);
	
	    function ReactSwipe() {
	      var _ref;
	
	      _classCallCheck(this, ReactSwipe);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));
	
	      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
	      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
	      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
	
	      _this._onMouseDown = _this._onMouseDown.bind(_this);
	      _this._onMouseMove = _this._onMouseMove.bind(_this);
	      _this._onMouseUp = _this._onMouseUp.bind(_this);
	      return _this;
	    }
	
	    _createClass(ReactSwipe, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.swiper) {
	          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.swiper) {
	          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: '_onMouseDown',
	      value: function _onMouseDown(event) {
	        if (!this.props.allowMouseEvents) {
	          return;
	        }
	
	        this.mouseDown = true;
	
	        document.addEventListener('mouseup', this._onMouseUp);
	        document.addEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeStart(event);
	      }
	    }, {
	      key: '_onMouseMove',
	      value: function _onMouseMove(event) {
	        if (!this.mouseDown) {
	          return;
	        }
	
	        this._handleSwipeMove(event);
	      }
	    }, {
	      key: '_onMouseUp',
	      value: function _onMouseUp(event) {
	        this.mouseDown = false;
	
	        document.removeEventListener('mouseup', this._onMouseUp);
	        document.removeEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeEnd(event);
	      }
	    }, {
	      key: '_handleSwipeStart',
	      value: function _handleSwipeStart(event) {
	        var _getPosition = getPosition(event),
	            x = _getPosition.x,
	            y = _getPosition.y;
	
	        this.moveStart = { x: x, y: y };
	        this.props.onSwipeStart(event);
	      }
	    }, {
	      key: '_handleSwipeMove',
	      value: function _handleSwipeMove(event) {
	        var _getPosition2 = getPosition(event),
	            x = _getPosition2.x,
	            y = _getPosition2.y;
	
	        var deltaX = x - this.moveStart.x;
	        var deltaY = y - this.moveStart.y;
	        this.moving = true;
	
	        // handling the responsability of cancelling the scroll to
	        // the component handling the event
	        var shouldPreventDefault = this.props.onSwipeMove({
	          x: deltaX,
	          y: deltaY
	        }, event);
	
	        if (shouldPreventDefault) {
	          event.preventDefault();
	        }
	
	        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
	      }
	    }, {
	      key: '_handleSwipeEnd',
	      value: function _handleSwipeEnd(event) {
	        this.props.onSwipeEnd(event);
	
	        var tolerance = this.props.tolerance;
	
	
	        if (this.moving) {
	          if (this.movePosition.deltaX < -tolerance) {
	            this.props.onSwipeLeft(1, event);
	          } else if (this.movePosition.deltaX > tolerance) {
	            this.props.onSwipeRight(1, event);
	          }
	          if (this.movePosition.deltaY < -tolerance) {
	            this.props.onSwipeUp(1, event);
	          } else if (this.movePosition.deltaY > tolerance) {
	            this.props.onSwipeDown(1, event);
	          }
	        }
	
	        this.moveStart = null;
	        this.moving = false;
	        this.movePosition = null;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          this.props.tagName,
	          {
	            ref: function ref(node) {
	              return _this2.swiper = node;
	            },
	            onMouseDown: this._onMouseDown,
	            onTouchStart: this._handleSwipeStart,
	            onTouchEnd: this._handleSwipeEnd,
	            className: this.props.className,
	            style: this.props.style
	          },
	          this.props.children
	        );
	      }
	    }]);
	
	    return ReactSwipe;
	  }(_react.Component);
	
	  ReactSwipe.displayName = 'ReactSwipe';
	  ReactSwipe.propTypes = {
	    tagName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    allowMouseEvents: _propTypes2.default.bool,
	    onSwipeUp: _propTypes2.default.func,
	    onSwipeDown: _propTypes2.default.func,
	    onSwipeLeft: _propTypes2.default.func,
	    onSwipeRight: _propTypes2.default.func,
	    onSwipeStart: _propTypes2.default.func,
	    onSwipeMove: _propTypes2.default.func,
	    onSwipeEnd: _propTypes2.default.func,
	    tolerance: _propTypes2.default.number.isRequired
	  };
	  ReactSwipe.defaultProps = {
	    tagName: 'div',
	    allowMouseEvents: false,
	    onSwipeUp: function onSwipeUp() {},
	    onSwipeDown: function onSwipeDown() {},
	    onSwipeLeft: function onSwipeLeft() {},
	    onSwipeRight: function onSwipeRight() {},
	    onSwipeStart: function onSwipeStart() {},
	    onSwipeMove: function onSwipeMove() {},
	    onSwipeEnd: function onSwipeEnd() {},
	
	    tolerance: 0
	  };
	  exports.default = ReactSwipe;
	});

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (position, axis) {
	    var positionCss = axis === 'horizontal' ? [position, 0, 0] : [0, position, 0];
	    var transitionProp = 'translate3d';
	
	    var translatedPosition = '(' + positionCss.join(',') + ')';
	
	    return transitionProp + translatedPosition;
	};

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(53);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssClasses = __webpack_require__(138);
	
	var _cssClasses2 = _interopRequireDefault(_cssClasses);
	
	var _CSSTranslate = __webpack_require__(136);
	
	var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);
	
	var _reactEasySwipe = __webpack_require__(134);
	
	var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);
	
	var _Thumbs = __webpack_require__(137);
	
	var _Thumbs2 = _interopRequireDefault(_Thumbs);
	
	var _customPropTypes = __webpack_require__(326);
	
	var customPropTypes = _interopRequireWildcard(_customPropTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {};
	
	var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
	    return current + ' of ' + total;
	};
	
	var Carousel = function (_Component) {
	    _inherits(Carousel, _Component);
	
	    function Carousel(props) {
	        _classCallCheck(this, Carousel);
	
	        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));
	
	        _this.autoPlay = function () {
	            if (!_this.props.autoPlay) {
	                return;
	            }
	
	            clearTimeout(_this.timer);
	            _this.timer = setTimeout(function () {
	                _this.increment();
	            }, _this.props.interval);
	        };
	
	        _this.clearAutoPlay = function () {
	            if (!_this.props.autoPlay) {
	                return;
	            }
	
	            clearTimeout(_this.timer);
	        };
	
	        _this.resetAutoPlay = function () {
	            _this.clearAutoPlay();
	            _this.autoPlay();
	        };
	
	        _this.stopOnHover = function () {
	            _this.setState({ isMouseEntered: true });
	            _this.clearAutoPlay();
	        };
	
	        _this.startOnLeave = function () {
	            _this.setState({ isMouseEntered: false });
	            _this.autoPlay();
	        };
	
	        _this.navigateWithKeyboard = function (e) {
	            var axis = _this.props.axis;
	
	            var isHorizontal = axis === 'horizontal';
	            var keyNames = {
	                ArrowUp: 38,
	                ArrowRight: 39,
	                ArrowDown: 40,
	                ArrowLeft: 37
	            };
	
	            var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
	            var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
	
	            if (nextKey === e.keyCode) {
	                _this.increment();
	            } else if (prevKey === e.keyCode) {
	                _this.decrement();
	            }
	        };
	
	        _this.updateSizes = function () {
	            if (!_this.state.initialized) {
	                return;
	            }
	
	            var isHorizontal = _this.props.axis === 'horizontal';
	            var firstItem = _this.refs.item0;
	            var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
	
	            _this.setState({
	                itemSize: itemSize,
	                wrapperSize: isHorizontal ? itemSize * _this.props.children.length : itemSize
	            });
	        };
	
	        _this.setMountState = function () {
	            _this.setState({ hasMount: true });
	            _this.updateSizes();
	        };
	
	        _this.handleClickItem = function (index, item) {
	            if (_this.state.cancelClick) {
	                _this.setState({
	                    cancelClick: false
	                });
	
	                return;
	            }
	
	            _this.props.onClickItem(index, item);
	
	            if (index !== _this.state.selectedItem) {
	                _this.setState({
	                    selectedItem: index
	                });
	            }
	        };
	
	        _this.handleOnChange = function (index, item) {
	            _this.props.onChange(index, item);
	        };
	
	        _this.handleClickThumb = function (index, item) {
	            _this.props.onClickThumb(index, item);
	
	            _this.selectItem({
	                selectedItem: index
	            });
	        };
	
	        _this.onSwipeStart = function () {
	            _this.setState({
	                swiping: true
	            });
	            _this.clearAutoPlay();
	        };
	
	        _this.onSwipeEnd = function () {
	            _this.resetPosition();
	            _this.setState({
	                swiping: false
	            });
	            _this.autoPlay();
	        };
	
	        _this.onSwipeMove = function (delta) {
	            var isHorizontal = _this.props.axis === 'horizontal';
	
	            var initialBoundry = 0;
	
	            var currentPosition = _this.getPosition(_this.state.selectedItem);
	            var finalBoundry = _this.getPosition(_this.props.children.length - 1);
	
	            var axisDelta = isHorizontal ? delta.x : delta.y;
	            var handledDelta = axisDelta;
	
	            // prevent user from swiping left out of boundaries
	            if (currentPosition === initialBoundry && axisDelta > 0) {
	                handledDelta = 0;
	            }
	
	            // prevent user from swiping right out of boundaries
	            if (currentPosition === finalBoundry && axisDelta < 0) {
	                handledDelta = 0;
	            }
	
	            var position = currentPosition + 100 / (_this.state.itemSize / handledDelta) + '%';
	
	            _this.setPosition(position);
	
	            // allows scroll if the swipe was within the tolerance
	            var hasMoved = Math.abs(axisDelta) > _this.props.swipeScrollTolerance;
	
	            if (hasMoved && !_this.state.cancelClick) {
	                _this.setState({
	                    cancelClick: true
	                });
	            }
	
	            return hasMoved;
	        };
	
	        _this.resetPosition = function () {
	            var currentPosition = _this.getPosition(_this.state.selectedItem) + '%';
	            _this.setPosition(currentPosition);
	        };
	
	        _this.setPosition = function (position) {
	            var list = _reactDom2.default.findDOMNode(_this.refs.itemList);
	            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	                list.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
	            });
	        };
	
	        _this.decrement = function (positions) {
	            _this.moveTo(_this.state.selectedItem - (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.increment = function (positions) {
	            _this.moveTo(_this.state.selectedItem + (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.moveTo = function (position) {
	            var lastPosition = _this.props.children.length - 1;
	
	            if (position < 0) {
	                position = _this.props.infiniteLoop ? lastPosition : 0;
	            }
	
	            if (position > lastPosition) {
	                position = _this.props.infiniteLoop ? 0 : lastPosition;
	            }
	
	            _this.selectItem({
	                // if it's not a slider, we don't need to set position here
	                selectedItem: position
	            });
	
	            // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
	            // and will result in the interval function not being cleared correctly.
	            if (_this.props.autoPlay && _this.state.isMouseEntered === false) {
	                _this.resetAutoPlay();
	            }
	        };
	
	        _this.changeItem = function (e) {
	            var newIndex = e.target.value;
	
	            _this.selectItem({
	                selectedItem: newIndex
	            });
	        };
	
	        _this.selectItem = function (state) {
	            _this.setState(state);
	            _this.handleOnChange(state.selectedItem, _this.props.children[state.selectedItem]);
	        };
	
	        _this.getInitialImage = function () {
	            var selectedItem = _this.props.selectedItem;
	            var item = _this.refs['item' + selectedItem];
	            var images = item && item.getElementsByTagName('img');
	            return images && images[selectedItem];
	        };
	
	        _this.getVariableImageHeight = function (position) {
	            var item = _this.refs['item' + position];
	            var images = item && item.getElementsByTagName('img');
	            if (_this.state.hasMount && images.length > 0) {
	                var image = images[0];
	
	                if (!image.complete) {
	                    // if the image is still loading, the size won't be available so we trigger a new render after it's done
	                    var onImageLoad = function onImageLoad() {
	                        _this.forceUpdate();
	                        image.removeEventListener('load', onImageLoad);
	                    };
	
	                    image.addEventListener('load', onImageLoad);
	                }
	
	                var height = image.clientHeight;
	                return height > 0 ? height : null;
	            }
	
	            return null;
	        };
	
	        _this.state = {
	            initialized: false,
	            selectedItem: props.selectedItem,
	            hasMount: false,
	            isMouseEntered: false
	        };
	        return _this;
	    }
	
	    _createClass(Carousel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.children) {
	                return;
	            }
	
	            this.setupCarousel();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.selectedItem !== this.state.selectedItem) {
	                this.updateSizes();
	                this.moveTo(nextProps.selectedItem);
	            }
	
	            if (nextProps.autoPlay !== this.props.autoPlay) {
	                if (nextProps.autoPlay) {
	                    this.setupAutoPlay();
	                } else {
	                    this.destroyAutoPlay();
	                }
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!prevProps.children && this.props.children && !this.state.initialized) {
	                this.setupCarousel();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.destroyCarousel();
	        }
	    }, {
	        key: 'setupCarousel',
	        value: function setupCarousel() {
	            this.bindEvents();
	
	            if (this.props.autoPlay) {
	                this.setupAutoPlay();
	            }
	
	            this.setState({
	                initialized: true
	            });
	
	            var initialImage = this.getInitialImage();
	            if (initialImage) {
	                // if it's a carousel of images, we set the mount state after the first image is loaded
	                initialImage.addEventListener('load', this.setMountState);
	            } else {
	                this.setMountState();
	            }
	        }
	    }, {
	        key: 'destroyCarousel',
	        value: function destroyCarousel() {
	            if (this.state.initialized) {
	                this.unbindEvents();
	                this.destroyAutoPlay();
	            }
	        }
	    }, {
	        key: 'setupAutoPlay',
	        value: function setupAutoPlay() {
	            this.autoPlay();
	            var carouselWrapper = this.refs['carouselWrapper'];
	
	            if (this.props.stopOnHover && carouselWrapper) {
	                carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
	                carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
	            }
	        }
	    }, {
	        key: 'destroyAutoPlay',
	        value: function destroyAutoPlay() {
	            this.clearAutoPlay();
	            var carouselWrapper = this.refs['carouselWrapper'];
	
	            if (this.props.stopOnHover && carouselWrapper) {
	                carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
	                carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
	            }
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            // as the widths are calculated, we need to resize
	            // the carousel when the window is resized
	            window.addEventListener("resize", this.updateSizes);
	            // issue #2 - image loading smaller
	            window.addEventListener("DOMContentLoaded", this.updateSizes);
	
	            if (this.props.useKeyboardArrows) {
	                document.addEventListener("keydown", this.navigateWithKeyboard);
	            }
	        }
	    }, {
	        key: 'unbindEvents',
	        value: function unbindEvents() {
	            // removing listeners
	            window.removeEventListener("resize", this.updateSizes);
	            window.removeEventListener("DOMContentLoaded", this.updateSizes);
	
	            var initialImage = this.getInitialImage();
	            if (initialImage) {
	                initialImage.removeEventListener("load", this.setMountState);
	            }
	
	            if (this.props.useKeyboardArrows) {
	                document.removeEventListener("keydown", this.navigateWithKeyboard);
	            }
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(index) {
	            if (this.props.centerMode && this.props.axis === 'horizontal') {
	                var currentPosition = -index * this.props.centerSlidePercentage;
	                var lastPosition = this.props.children.length - 1;
	
	                if (index && index !== lastPosition) {
	                    currentPosition += (100 - this.props.centerSlidePercentage) / 2;
	                } else if (index === lastPosition) {
	                    currentPosition += 100 - this.props.centerSlidePercentage;
	                }
	
	                return currentPosition;
	            }
	
	            return -index * 100;
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _this2 = this;
	
	            return _react2.default.Children.map(this.props.children, function (item, index) {
	                var itemClass = _cssClasses2.default.ITEM(true, index === _this2.state.selectedItem);
	                var slideProps = {
	                    ref: 'item' + index,
	                    key: 'itemKey' + index,
	                    className: _cssClasses2.default.ITEM(true, index === _this2.state.selectedItem),
	                    onClick: _this2.handleClickItem.bind(_this2, index, item)
	                };
	
	                if (_this2.props.centerMode && _this2.props.axis === 'horizontal') {
	                    slideProps.style = {
	                        minWidth: _this2.props.centerSlidePercentage + '%'
	                    };
	                }
	
	                return _react2.default.createElement(
	                    'li',
	                    slideProps,
	                    item
	                );
	            });
	        }
	    }, {
	        key: 'renderControls',
	        value: function renderControls() {
	            var _this3 = this;
	
	            if (!this.props.showIndicators) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'control-dots' },
	                _react2.default.Children.map(this.props.children, function (item, index) {
	                    return _react2.default.createElement('li', { className: _cssClasses2.default.DOT(index === _this3.state.selectedItem), onClick: _this3.changeItem, value: index, key: index });
	                })
	            );
	        }
	    }, {
	        key: 'renderStatus',
	        value: function renderStatus() {
	            if (!this.props.showStatus) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'p',
	                { className: 'carousel-status' },
	                this.props.statusFormatter(this.state.selectedItem + 1, this.props.children.length)
	            );
	        }
	    }, {
	        key: 'renderThumbs',
	        value: function renderThumbs() {
	            if (!this.props.showThumbs || this.props.children.length === 0) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                _Thumbs2.default,
	                { onSelectItem: this.handleClickThumb, selectedItem: this.state.selectedItem, transitionTime: this.props.transitionTime, thumbWidth: this.props.thumbWidth },
	                this.props.children
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.children || this.props.children.length === 0) {
	                return null;
	            }
	
	            var itemsLength = this.props.children.length;
	
	            var isHorizontal = this.props.axis === 'horizontal';
	
	            var canShowArrows = this.props.showArrows && itemsLength > 1;
	
	            // show left arrow?
	            var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop);
	            // show right arrow
	            var hasNext = canShowArrows && (this.state.selectedItem < itemsLength - 1 || this.props.infiniteLoop);
	            // obj to hold the transformations and styles
	            var itemListStyles = {};
	
	            var currentPosition = this.getPosition(this.state.selectedItem);
	
	            // if 3d is available, let's take advantage of the performance of transform
	            var transformProp = (0, _CSSTranslate2.default)(currentPosition + '%', this.props.axis);
	
	            var transitionTime = this.props.transitionTime + 'ms';
	
	            itemListStyles = {
	                'WebkitTransform': transformProp,
	                'MozTransform': transformProp,
	                'MsTransform': transformProp,
	                'OTransform': transformProp,
	                'transform': transformProp,
	                'msTransform': transformProp
	            };
	
	            if (!this.state.swiping) {
	                itemListStyles = _extends({}, itemListStyles, {
	                    'WebkitTransitionDuration': transitionTime,
	                    'MozTransitionDuration': transitionTime,
	                    'MsTransitionDuration': transitionTime,
	                    'OTransitionDuration': transitionTime,
	                    'transitionDuration': transitionTime,
	                    'msTransitionDuration': transitionTime
	                });
	            }
	
	            var swiperProps = {
	                selectedItem: this.state.selectedItem,
	                className: _cssClasses2.default.SLIDER(true, this.state.swiping),
	                onSwipeMove: this.onSwipeMove,
	                onSwipeStart: this.onSwipeStart,
	                onSwipeEnd: this.onSwipeEnd,
	                style: itemListStyles,
	                tolerance: this.props.swipeScrollTolerance,
	                ref: 'itemList'
	            };
	
	            var containerStyles = {};
	
	            if (isHorizontal) {
	                swiperProps.onSwipeLeft = this.increment;
	                swiperProps.onSwipeRight = this.decrement;
	
	                if (this.props.dynamicHeight) {
	                    var itemHeight = this.getVariableImageHeight(this.state.selectedItem);
	                    swiperProps.style.height = itemHeight || 'auto';
	                    containerStyles.height = itemHeight || 'auto';
	                }
	            } else {
	                swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.increment : this.decrement;
	                swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.decrement : this.increment;
	                swiperProps.style.height = this.state.itemSize;
	                containerStyles.height = this.state.itemSize;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.className, ref: 'carouselWrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: _cssClasses2.default.CAROUSEL(true), style: { width: this.props.width } },
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.decrement }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _cssClasses2.default.WRAPPER(true, this.props.axis), style: containerStyles, ref: 'itemsWrapper' },
	                        _react2.default.createElement(
	                            _reactEasySwipe2.default,
	                            _extends({ tagName: 'ul' }, swiperProps, { allowMouseEvents: this.props.emulateTouch }),
	                            this.renderItems()
	                        )
	                    ),
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.increment }),
	                    this.renderControls(),
	                    this.renderStatus()
	                ),
	                this.renderThumbs()
	            );
	        }
	    }]);
	
	    return Carousel;
	}(_react.Component);
	
	Carousel.displayName = 'Carousel';
	Carousel.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    showArrows: _propTypes2.default.bool,
	    showStatus: _propTypes2.default.bool,
	    showIndicators: _propTypes2.default.bool,
	    infiniteLoop: _propTypes2.default.bool,
	    showThumbs: _propTypes2.default.bool,
	    thumbWidth: _propTypes2.default.number,
	    selectedItem: _propTypes2.default.number,
	    onClickItem: _propTypes2.default.func.isRequired,
	    onClickThumb: _propTypes2.default.func.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    axis: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    verticalSwipe: _propTypes2.default.oneOf(['natural', 'standard']),
	    width: customPropTypes.unit,
	    useKeyboardArrows: _propTypes2.default.bool,
	    autoPlay: _propTypes2.default.bool,
	    stopOnHover: _propTypes2.default.bool,
	    interval: _propTypes2.default.number,
	    transitionTime: _propTypes2.default.number,
	    swipeScrollTolerance: _propTypes2.default.number,
	    dynamicHeight: _propTypes2.default.bool,
	    emulateTouch: _propTypes2.default.bool,
	    statusFormatter: _propTypes2.default.func.isRequired,
	    centerMode: _propTypes2.default.bool,
	    centerSlidePercentage: _propTypes2.default.number
	};
	Carousel.defaultProps = {
	    showIndicators: true,
	    showArrows: true,
	    showStatus: true,
	    showThumbs: true,
	    infiniteLoop: false,
	    selectedItem: 0,
	    axis: 'horizontal',
	    verticalSwipe: 'standard',
	    width: '100%',
	    useKeyboardArrows: false,
	    autoPlay: false,
	    stopOnHover: true,
	    interval: 3000,
	    transitionTime: 350,
	    swipeScrollTolerance: 5,
	    dynamicHeight: false,
	    emulateTouch: false,
	    onClickItem: noop,
	    onClickThumb: noop,
	    onChange: noop,
	    statusFormatter: defaultStatusFormatter,
	    centerMode: false,
	    centerSlidePercentage: 80
	};
	exports.default = Carousel;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(53);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssClasses = __webpack_require__(138);
	
	var _cssClasses2 = _interopRequireDefault(_cssClasses);
	
	var _dimensions = __webpack_require__(327);
	
	var _CSSTranslate = __webpack_require__(136);
	
	var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);
	
	var _reactEasySwipe = __webpack_require__(134);
	
	var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Thumbs = function (_Component) {
	    _inherits(Thumbs, _Component);
	
	    function Thumbs(props) {
	        _classCallCheck(this, Thumbs);
	
	        var _this = _possibleConstructorReturn(this, (Thumbs.__proto__ || Object.getPrototypeOf(Thumbs)).call(this, props));
	
	        _this.updateSizes = function () {
	            if (!_this.state.initialized) {
	                return;
	            }
	
	            var total = _this.props.children.length;
	            _this.wrapperSize = _this.itemsWrapper.clientWidth;
	            _this.itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.refs.thumb0);
	            _this.visibleItems = Math.floor(_this.wrapperSize / _this.itemSize);
	            _this.lastPosition = total - _this.visibleItems;
	            _this.showArrows = _this.visibleItems < total;
	        };
	
	        _this.setMountState = function () {
	            _this.setState({ hasMount: true });
	            _this.updateSizes();
	        };
	
	        _this.handleClickItem = function (index, item) {
	            var handler = _this.props.onSelectItem;
	
	            if (typeof handler === 'function') {
	                handler(index, item);
	            }
	        };
	
	        _this.onSwipeStart = function () {
	            _this.setState({
	                swiping: true
	            });
	        };
	
	        _this.onSwipeEnd = function () {
	            _this.setState({
	                swiping: false
	            });
	        };
	
	        _this.onSwipeMove = function (deltaX) {
	            var leftBoundry = 0;
	            var list = _reactDom2.default.findDOMNode(_this.itemList);
	            var wrapperSize = list.clientWidth;
	            var visibleItems = Math.floor(wrapperSize / _this.itemSize);
	
	            var currentPosition = -_this.state.firstItem * _this.itemSize;
	            var lastLeftBoundry = -_this.visibleItems * _this.itemSize;
	
	            // prevent user from swiping left out of boundaries
	            if (currentPosition === leftBoundry && deltaX > 0) {
	                deltaX = 0;
	            }
	
	            // prevent user from swiping right out of boundaries
	            if (currentPosition === lastLeftBoundry && deltaX < 0) {
	                deltaX = 0;
	            }
	
	            var position = currentPosition + 100 / (wrapperSize / deltaX) + '%';
	
	            // if 3d isn't available we will use left to move
	            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	                list.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
	            });
	        };
	
	        _this.slideRight = function (positions) {
	            _this.moveTo(_this.state.firstItem - (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.slideLeft = function (positions) {
	            _this.moveTo(_this.state.firstItem + (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.moveTo = function (position) {
	            // position can't be lower than 0
	            position = position < 0 ? 0 : position;
	            // position can't be higher than last postion
	            position = position >= _this.lastPosition ? _this.lastPosition : position;
	
	            _this.setState({
	                firstItem: position,
	                // if it's not a slider, we don't need to set position here
	                selectedItem: _this.state.selectedItem
	            });
	        };
	
	        _this.state = {
	            initialized: false,
	            selectedItem: props.selectedItem,
	            hasMount: false,
	            firstItem: _this.getFirstItem(props.selectedItem),
	            images: []
	        };
	        return _this;
	    }
	
	    _createClass(Thumbs, [{
	        key: 'componentDidMount',
	        value: function componentDidMount(nextProps) {
	            if (!this.props.children) {
	                return;
	            }
	
	            this.setupThumbs();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props, state) {
	            if (props.selectedItem !== this.state.selectedItem) {
	                this.setState({
	                    selectedItem: props.selectedItem,
	                    firstItem: this.getFirstItem(props.selectedItem)
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!prevProps.children && this.props.children && !this.state.initialized) {
	                this.setupThumbs();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.destroyThumbs();
	        }
	    }, {
	        key: 'setupThumbs',
	        value: function setupThumbs() {
	            // as the widths are calculated, we need to resize
	            // the carousel when the window is resized
	            window.addEventListener("resize", this.updateSizes);
	            // issue #2 - image loading smaller
	            window.addEventListener("DOMContentLoaded", this.updateSizes);
	
	            var images = this.getImages();
	
	            if (!images) {
	                return;
	            }
	
	            this.setState({
	                initialized: true,
	                images: images
	            });
	
	            // when the component is rendered we need to calculate
	            // the container size to adjust the responsive behaviour
	            this.updateSizes();
	        }
	    }, {
	        key: 'destroyThumbs',
	        value: function destroyThumbs() {
	            // removing listeners
	            window.removeEventListener("resize", this.updateSizes);
	            window.removeEventListener("DOMContentLoaded", this.updateSizes);
	        }
	    }, {
	        key: 'getImages',
	        value: function getImages() {
	            var images = _react2.default.Children.map(this.props.children, function (item, index) {
	                var img = item;
	
	                // if the item is not an image, try to find the first image in the item's children.
	                if (item.type !== "img") {
	                    img = _react2.default.Children.toArray(item.props.children).filter(function (children) {
	                        return children.type === "img";
	                    })[0];
	                }
	
	                if (!img || img.length === 0) {
	                    return null;
	                }
	
	                return img;
	            });
	
	            if (images.filter(function (image) {
	                return image !== null;
	            }).length === 0) {
	                console.warn('No images found! Can\'t build the thumb list without images. If you don\'t need thumbs, set showThumbs={false} in the Carousel. Note that it\'s not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md');
	
	                return null;
	            }
	
	            return images;
	        }
	    }, {
	        key: 'getFirstItem',
	        value: function getFirstItem(selectedItem) {
	            if (!this.showArrows) {
	                return 0;
	            }
	
	            var firstItem = selectedItem;
	
	            if (selectedItem >= this.lastPosition) {
	                firstItem = this.lastPosition;
	            }
	
	            if (selectedItem < this.state.firstItem + this.visibleItems) {
	                firstItem = this.state.firstItem;
	            }
	
	            if (selectedItem < this.state.firstItem) {
	                firstItem = selectedItem;
	            }
	
	            return firstItem;
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _this2 = this;
	
	            return this.state.images.map(function (img, index) {
	                var itemClass = _cssClasses2.default.ITEM(false, index === _this2.state.selectedItem && _this2.state.hasMount);
	
	                var thumbProps = {
	                    key: index,
	                    ref: 'thumb' + index,
	                    className: itemClass,
	                    onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index])
	                };
	
	                if (index === 0) {
	                    img = _react2.default.cloneElement(img, {
	                        onLoad: _this2.setMountState
	                    });
	                }
	
	                return _react2.default.createElement(
	                    'li',
	                    thumbProps,
	                    img
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            if (!this.props.children || this.state.images.length === 0) {
	                return null;
	            }
	
	            // show left arrow?
	            var hasPrev = this.showArrows && this.state.firstItem > 0;
	            // show right arrow
	            var hasNext = this.showArrows && this.state.firstItem < this.lastPosition;
	            // obj to hold the transformations and styles
	            var itemListStyles = {};
	
	            var currentPosition = -this.state.firstItem * this.itemSize + 'px';
	
	            var transformProp = (0, _CSSTranslate2.default)(currentPosition, this.props.axis);
	
	            var transitionTime = this.props.transitionTime + 'ms';
	
	            itemListStyles = {
	                'WebkitTransform': transformProp,
	                'MozTransform': transformProp,
	                'MsTransform': transformProp,
	                'OTransform': transformProp,
	                'transform': transformProp,
	                'msTransform': transformProp,
	                'WebkitTransitionDuration': transitionTime,
	                'MozTransitionDuration': transitionTime,
	                'MsTransitionDuration': transitionTime,
	                'OTransitionDuration': transitionTime,
	                'transitionDuration': transitionTime,
	                'msTransitionDuration': transitionTime
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _cssClasses2.default.CAROUSEL(false) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _cssClasses2.default.WRAPPER(false), ref: function ref(node) {
	                            return _this3.itemsWrapper = node;
	                        } },
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.slideRight }),
	                    _react2.default.createElement(
	                        _reactEasySwipe2.default,
	                        { tagName: 'ul',
	                            selectedItem: this.state.selectedItem,
	                            className: _cssClasses2.default.SLIDER(false, this.state.swiping),
	                            onSwipeLeft: this.slideLeft,
	                            onSwipeRight: this.slideRight,
	                            onSwipeMove: this.onSwipeMove,
	                            onSwipeStart: this.onSwipeStart,
	                            onSwipeEnd: this.onSwipeEnd,
	                            style: itemListStyles,
	                            ref: function ref(node) {
	                                return _this3.itemList = node;
	                            } },
	                        this.renderItems()
	                    ),
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.slideLeft })
	                )
	            );
	        }
	    }]);
	
	    return Thumbs;
	}(_react.Component);
	
	Thumbs.displayName = 'Thumbs';
	Thumbs.propsTypes = {
	    children: _propTypes2.default.element.isRequired,
	    transitionTime: _propTypes2.default.number,
	    selectedItem: _propTypes2.default.number,
	    thumbWidth: _propTypes2.default.number
	};
	Thumbs.defaultProps = {
	    selectedItem: 0,
	    transitionTime: 350,
	    axis: 'horizontal'
	};
	exports.default = Thumbs;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    CAROUSEL: function CAROUSEL(isSlider) {
	        return (0, _classnames2.default)({
	            "carousel": true,
	            "carousel-slider": isSlider
	        });
	    },
	
	    WRAPPER: function WRAPPER(isSlider, axis) {
	        return (0, _classnames2.default)({
	            "thumbs-wrapper": !isSlider,
	            "slider-wrapper": isSlider,
	            "axis-horizontal": axis === "horizontal",
	            "axis-vertical": axis !== "horizontal"
	        });
	    },
	
	    SLIDER: function SLIDER(isSlider, isSwiping) {
	        return (0, _classnames2.default)({
	            "thumbs": !isSlider,
	            "slider": isSlider,
	            "animated": !isSwiping
	        });
	    },
	
	    ITEM: function ITEM(isSlider, selected) {
	        return (0, _classnames2.default)({
	            "thumb": !isSlider,
	            "slide": isSlider,
	            "selected": selected
	        });
	    },
	
	    ARROW_PREV: function ARROW_PREV(disabled) {
	        return (0, _classnames2.default)({
	            "control-arrow control-prev": true,
	            "control-disabled": disabled
	        });
	    },
	
	    ARROW_NEXT: function ARROW_NEXT(disabled) {
	        return (0, _classnames2.default)({
	            "control-arrow control-next": true,
	            "control-disabled": disabled
	        });
	    },
	
	    DOT: function DOT(selected) {
	        return (0, _classnames2.default)({
	            "dot": true,
	            'selected': selected
	        });
	    }
	};

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var unit = exports.unit = function unit(props, propName, componentName) {
	    if (!/(pt|px|em|rem|vw|vh|%)$/.test(props[propName])) {
	        return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed. It needs to be a size unit like pt, px, em, rem, vw, %');
	    }
	};

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var outerWidth = exports.outerWidth = function outerWidth(el) {
		var width = el.offsetWidth;
		var style = getComputedStyle(el);
	
		width += parseInt(style.marginLeft) + parseInt(style.marginRight);
		return width;
	};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Thumbs = exports.Carousel = undefined;
	
	var _Carousel = __webpack_require__(325);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Thumbs = __webpack_require__(137);
	
	var _Thumbs2 = _interopRequireDefault(_Thumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Carousel = _Carousel2.default;
	exports.Thumbs = _Thumbs2.default;

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailMe = function EmailMe(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    "a",
	    { className: className, rel: "noopener", href: "mailto:simon@borrowedverse.com" },
	    text
	  );
	};
	
	EmailMe.propTypes = {
	  className: _propTypes2.default.string,
	  text: _propTypes2.default.string.isRequired
	};
	
	EmailMe.defaultProps = {
	  className: ""
	};
	
	exports.default = EmailMe;
	module.exports = exports["default"];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(269);
	
	var _style = __webpack_require__(168);
	
	var _shared = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WorksFeaturedSection = function (_Component) {
	  _inherits(WorksFeaturedSection, _Component);
	
	  function WorksFeaturedSection() {
	    _classCallCheck(this, WorksFeaturedSection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = { widthLoaded: false, isMobile: false };
	    _this.setMobile = _this.setMobile.bind(_this);
	    return _this;
	  }
	
	  WorksFeaturedSection.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      this.setMobile();
	      window.addEventListener('resize', this.setMobile);
	    }
	  };
	
	  WorksFeaturedSection.prototype.componentWillUnmount = function componentWillUnmount() {
	    typeof window !== 'undefined' && window.removeEventListener('resize', this.setMobile);
	  };
	
	  WorksFeaturedSection.prototype.setWidthLoaded = function setWidthLoaded() {
	    this.setState({ widthLoaded: true });
	  };
	
	  WorksFeaturedSection.prototype.setMobile = function setMobile() {
	    var _this2 = this;
	
	    this.setState({
	      isMobile: window.innerWidth < 480
	    }, function () {
	      return _this2.setWidthLoaded();
	    });
	  };
	
	  WorksFeaturedSection.prototype.renderWorksList = function renderWorksList(_ref) {
	    var work = _ref.work;
	    var title = work.title,
	        image = work.image,
	        url = work.url;
	
	    return _react2.default.createElement(
	      _style.WorkFeatured,
	      { key: title },
	      _react2.default.createElement(_style.StyledImage, _extends({
	        alt: title,
	        loader: function loader(_ref2) {
	          var isLoaded = _ref2.isLoaded;
	          return _react2.default.createElement(_shared.Loader, { isLoaded: isLoaded });
	        }
	      }, image)),
	      url && _react2.default.createElement(
	        'a',
	        { href: url, target: '_blank', rel: 'noopener noreferrer' },
	        'More Info'
	      )
	    );
	  };
	
	  WorksFeaturedSection.prototype.renderWorksWrapper = function renderWorksWrapper() {
	    var works = this.props.works;
	    var isMobile = this.state.isMobile;
	
	    var worksList = works.map(this.renderWorksList);
	    return isMobile ? _react2.default.createElement(
	      _style.StyledCarousel,
	      {
	        showArrows: false,
	        showThumbs: false,
	        showStatus: false,
	        interval: 10000,
	        autoPlay: true
	      },
	      worksList
	    ) : _react2.default.createElement(
	      _style.Wrapper,
	      null,
	      worksList
	    );
	  };
	
	  WorksFeaturedSection.prototype.render = function render() {
	    var widthLoaded = this.state.widthLoaded;
	
	    return widthLoaded && this.renderWorksWrapper();
	  };
	
	  return WorksFeaturedSection;
	}(_react.Component);
	
	exports.default = WorksFeaturedSection;
	module.exports = exports['default'];

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StyledCarousel = exports.Wrapper = exports.StyledImage = exports.WorkFeatured = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, .35);\n  transform: translateY(0);\n  transition: all .3s cubic-bezier(.45, 0, .1, 1);\n  transform-style: preserve-3d;\n  backface-visibility: hidden;\n  will-change: box-shadow, transform;\n\n  &:hover {\n    // transform: translateY(-.5rem);\n    // box-shadow: 0 20px 30px -10px rgba(0, 0, 0, .35);\n  }\n\n  a {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    font-size: 0;\n    line-height: 0;\n    z-index: 2;\n  }\n\n  ', '\n'], ['\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, .35);\n  transform: translateY(0);\n  transition: all .3s cubic-bezier(.45, 0, .1, 1);\n  transform-style: preserve-3d;\n  backface-visibility: hidden;\n  will-change: box-shadow, transform;\n\n  &:hover {\n    // transform: translateY(-.5rem);\n    // box-shadow: 0 20px 30px -10px rgba(0, 0, 0, .35);\n  }\n\n  a {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    font-size: 0;\n    line-height: 0;\n    z-index: 2;\n  }\n\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    box-shadow: none;\n    transform: translateY(0);\n    \n    &:hover {\n      box-shadow: none;\n      transform: translateY(0);     \n    }\n  '], ['\n    box-shadow: none;\n    transform: translateY(0);\n    \n    &:hover {\n      box-shadow: none;\n      transform: translateY(0);     \n    }\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: block;\n  position: relative;\n  background: #242e3a;\n  \n  &::before {\n    content: \'\';\n    padding-top: 74%;\n    display: block;\n    ', '\n  }\n\n  img {\n    position: absolute;\n    display: block;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    object-fit: cover;\n    z-index: 1;\n  }\n'], ['\n  display: block;\n  position: relative;\n  background: #242e3a;\n  \n  &::before {\n    content: \'\';\n    padding-top: 74%;\n    display: block;\n    ', '\n  }\n\n  img {\n    position: absolute;\n    display: block;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n    top: -100%;\n    right: -100%;\n    bottom: -100%;\n    left: -100%;\n    object-fit: cover;\n    z-index: 1;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      padding-top: 100%;\n    '], ['\n      padding-top: 100%;\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 2rem;\n  grid-row-gap: 2rem;\n'], ['\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 2rem;\n  grid-row-gap: 2rem;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  box-shadow: 0 10px 30px rgba(19, 27, 37, .4);\n  overflow: hidden;\n  border-radius: 2px;\n  \n  .carousel {\n    .slide {\n      background: transparent;\n    }\n\n    .control-dots {\n      margin: 0 0 1rem;\n      \n      .dot {\n        box-shadow: none;\n        height: 1px;\n        width: 1.5rem;\n        margin: 0 .25rem;\n        border-radius: 0;\n      }\n    }\n  }\n'], ['\n  box-shadow: 0 10px 30px rgba(19, 27, 37, .4);\n  overflow: hidden;\n  border-radius: 2px;\n  \n  .carousel {\n    .slide {\n      background: transparent;\n    }\n\n    .control-dots {\n      margin: 0 0 1rem;\n      \n      .dot {\n        box-shadow: none;\n        height: 1px;\n        width: 1.5rem;\n        margin: 0 .25rem;\n        border-radius: 0;\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactResponsiveCarousel = __webpack_require__(328);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var WorkFeatured = exports.WorkFeatured = _styledComponents2.default.article(_templateObject, _constants.media.sm(_templateObject2));
	
	var StyledImage = exports.StyledImage = (0, _styledComponents2.default)(_Image2.default)(_templateObject3, _constants.media.sm(_templateObject4));
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject5);
	
	var StyledCarousel = exports.StyledCarousel = (0, _styledComponents2.default)(_reactResponsiveCarousel.Carousel)(_templateObject6);

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorksListItem = function WorksListItem(props) {
	  var _props$work = props.work,
	      title = _props$work.title,
	      client = _props$work.client,
	      year = _props$work.year,
	      collaborators = _props$work.collaborators,
	      url = _props$work.url;
	
	
	  return _react2.default.createElement(
	    _style.Wrapper,
	    { hasLink: url !== null },
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _style.WorkTitle,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        _style.WorkInfos,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          client
	        ),
	        collaborators && _react2.default.createElement(
	          'span',
	          null,
	          ' w/ ',
	          collaborators.map(function (c) {
	            return c;
	          }).join(', ')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _style.WorkInfos,
	      null,
	      _react2.default.createElement(
	        _style.WorkYear,
	        null,
	        year
	      )
	    ),
	    url && _react2.default.createElement(
	      'a',
	      { href: url, target: '_blank', rel: 'noopener noreferrer' },
	      'More Info'
	    )
	  );
	};
	
	exports.default = WorksListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.WorkYear = exports.WorkInfos = exports.WorkTitle = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 1.3rem 0;\n  border-bottom: 1px dotted #2f3743;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n  position: relative;\n\n  > header {\n    transform: translateX(0);\n    transition: transform 0.5s cubic-bezier(0.5, 0.1, 0, 1.15);\n    backface-visibility: hidden;\n    will-change: transform;\n  }\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  > a {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    font-size: 0;\n    line-height: 0;\n  }\n\n  ", "\n"], ["\n  padding: 1.3rem 0;\n  border-bottom: 1px dotted #2f3743;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n  position: relative;\n\n  > header {\n    transform: translateX(0);\n    transition: transform 0.5s cubic-bezier(0.5, 0.1, 0, 1.15);\n    backface-visibility: hidden;\n    will-change: transform;\n  }\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  > a {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    font-size: 0;\n    line-height: 0;\n  }\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      ", "\n    "], ["\n      ", "\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n      &:hover {\n        > header {\n          transform: translateX(-.75rem);\n        }\n      }\n    "], ["\n      &:hover {\n        > header {\n          transform: translateX(-.75rem);\n        }\n      }\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 1.1rem;\n  color: #fff;\n  font-weight: 400;\n"], ["\n  font-size: 1.1rem;\n  color: #fff;\n  font-weight: 400;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-top: 0.5rem;\n  font-family: ", ";\n  font-size: 0.9rem;\n  color: ", ";\n  max-width: 32rem;\n"], ["\n  margin-top: 0.5rem;\n  font-family: ", ";\n  font-size: 0.9rem;\n  color: ", ";\n  max-width: 32rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n\n  &::before {\n    content: \"\";\n    display: inline-block;\n    vertical-align: middle;\n    height: 1px;\n    width: 1rem;\n    background: ", ";\n    margin-right: 0.5rem;\n  }\n"], ["\n  color: #fff;\n\n  &::before {\n    content: \"\";\n    display: inline-block;\n    vertical-align: middle;\n    height: 1px;\n    width: 1rem;\n    background: ", ";\n    margin-right: 0.5rem;\n  }\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.article(_templateObject, function (props) {
	  return props.hasLink && (0, _styledComponents.css)(_templateObject2, _constants.media.hover(_templateObject3));
	});
	
	var WorkTitle = exports.WorkTitle = _styledComponents2.default.h3(_templateObject4);
	
	var WorkInfos = exports.WorkInfos = _styledComponents2.default.div(_templateObject5, _constants.fonts.mono, _constants.colors.gray500);
	
	var WorkYear = exports.WorkYear = _styledComponents2.default.span(_templateObject6, _constants.colors.red500);

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Divider (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"profile","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-294.000000, -118.000000)"},React.createElement("g",{"id":"divider","transform":"translate(295.000000, 118.000000)","stroke":"#384653"},[React.createElement("polyline",{"id":"Triangle","points":"0 5 4.5 0 4.5 0 9 5","key":0}),React.createElement("polyline",{"id":"Triangle-Copy","points":"9 5 13.5 0 13.5 0 18 5","key":1}),React.createElement("polyline",{"id":"Triangle-Copy-2","points":"18 5 22.5 0 22.5 0 27 5","key":2}),React.createElement("polyline",{"id":"Triangle-Copy-3","points":"27 5 31.5 0 31.5 0 36 5","key":3})])));
	}
	
	Divider.displayName = "Divider";
	
	Divider.defaultProps = {"width":"38","height":"5","viewBox":"0 0 38 5","version":"1.1"};
	
	module.exports = Divider;
	
	Divider.default = Divider;


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WorksListItem = __webpack_require__(169);
	
	var _WorksListItem2 = _interopRequireDefault(_WorksListItem);
	
	var _style = __webpack_require__(172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorksListSection = function WorksListSection(_ref) {
	  var works = _ref.works,
	      category = _ref.category,
	      setCategory = _ref.setCategory;
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      "header",
	      null,
	      _react2.default.createElement(
	        _style.WorksTitle,
	        null,
	        "Events"
	      ),
	      _react2.default.createElement(
	        _style.ButtonsWrapper,
	        null,
	        _react2.default.createElement(
	          _style.FilterButton,
	          {
	            active: category === "future",
	            onClick: function onClick() {
	              return setCategory("future");
	            }
	          },
	          "future"
	        ),
	        _react2.default.createElement(
	          _style.FilterButton,
	          {
	            active: category === "past",
	            onClick: function onClick() {
	              return setCategory("past");
	            }
	          },
	          "past"
	        ),
	        category && _react2.default.createElement(
	          _style.FilterButton,
	          { onClick: function onClick() {
	              return setCategory(null);
	            } },
	          "all"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "main",
	      null,
	      works.map(function (_ref2, i) {
	        var work = _ref2.work;
	        return _react2.default.createElement(_WorksListItem2.default, { key: i, work: work });
	      })
	    )
	  );
	};
	
	exports.default = WorksListSection;
	module.exports = exports["default"];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.StyledEmailMe = exports.StyledDivider = exports.NDAWrapper = exports.FilterButton = exports.ButtonsWrapper = exports.WorksTitle = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 80%;\n  margin: 8rem auto 0;\n  ", "\n  ", "\n"], ["\n  max-width: 80%;\n  margin: 8rem auto 0;\n  ", "\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n  "], ["\n    max-width: 100%;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    margin: 4rem auto 0;\n  "], ["\n    margin: 4rem auto 0;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  font-size: 1.6rem;\n"], ["\n  font-size: 1.6rem;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  padding: 0.75rem 0 1.5rem;\n"], ["\n  padding: 0.75rem 0 1.5rem;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  border: 0;\n  background: 0;\n  padding: 0;\n  margin: 0;\n  appearance: none;\n  font-size: 0.9rem;\n  font-family: ", ";\n  cursor: pointer;\n\n  &:not(:last-child)::after {\n    content: \"-\";\n    display: inline-block;\n    margin: 0 0.5rem;\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  ", "\n"], ["\n  border: 0;\n  background: 0;\n  padding: 0;\n  margin: 0;\n  appearance: none;\n  font-size: 0.9rem;\n  font-family: ", ";\n  cursor: pointer;\n\n  &:not(:last-child)::after {\n    content: \"-\";\n    display: inline-block;\n    margin: 0 0.5rem;\n    color: ", ";\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  ", "\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  padding-top: 4rem;\n  text-align: center;\n\n  h2 {\n    font-size: 1.1rem;\n    color: #fff;\n    margin-bottom: 0.75rem;\n    line-height: 1.4em;\n  }\n"], ["\n  padding-top: 4rem;\n  text-align: center;\n\n  h2 {\n    font-size: 1.1rem;\n    color: #fff;\n    margin-bottom: 0.75rem;\n    line-height: 1.4em;\n  }\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 3rem;\n"], ["\n  margin-bottom: 3rem;\n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.9rem;\n  border-bottom: 1px dotted ", ";\n  padding: 0 0 0.1rem;\n  display: inline-block;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.9rem;\n  border-bottom: 1px dotted ", ";\n  padding: 0 0 0.1rem;\n  display: inline-block;\n\n  &:hover {\n    color: ", ";\n  }\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _EmailMe = __webpack_require__(57);
	
	var _EmailMe2 = _interopRequireDefault(_EmailMe);
	
	var _divider = __webpack_require__(369);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.section(_templateObject, _constants.media.lg(_templateObject2), _constants.media.sm(_templateObject3));
	
	var WorksTitle = exports.WorksTitle = _styledComponents2.default.h1(_templateObject4);
	
	var ButtonsWrapper = exports.ButtonsWrapper = _styledComponents2.default.div(_templateObject5);
	
	var FilterButton = exports.FilterButton = _styledComponents2.default.button(_templateObject6, _constants.fonts.mono, _constants.colors.gray500, function (props) {
	  return props.active ? (0, _styledComponents.css)(_templateObject7, _constants.colors.red500) : (0, _styledComponents.css)(_templateObject7, _constants.colors.gray500);
	});
	
	var NDAWrapper = exports.NDAWrapper = _styledComponents2.default.footer(_templateObject8);
	
	var StyledDivider = exports.StyledDivider = (0, _styledComponents2.default)(_divider2.default)(_templateObject9);
	
	var StyledEmailMe = exports.StyledEmailMe = (0, _styledComponents2.default)(_EmailMe2.default)(_templateObject10, _constants.colors.red500, _constants.fonts.mono, _constants.colors.red500, _constants.colors.red500);

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.worksQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _idx = __webpack_require__(305);
	
	var _idx2 = _interopRequireDefault(_idx);
	
	var _shared = __webpack_require__(5);
	
	var _WorksListSection = __webpack_require__(171);
	
	var _WorksListSection2 = _interopRequireDefault(_WorksListSection);
	
	var _WorksFeaturedSection = __webpack_require__(167);
	
	var _WorksFeaturedSection2 = _interopRequireDefault(_WorksFeaturedSection);
	
	var _Head = __webpack_require__(30);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _constants = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	  _inherits(_class, _Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.state = { category: null };
	    _this.setCategory = _this.setCategory.bind(_this);
	    return _this;
	  }
	
	  _class.prototype.setCategory = function setCategory(category) {
	    this.setState({ category: category });
	  };
	
	  _class.prototype.getData = function getData() {
	    var data = this.props.data;
	
	    return (0, _idx2.default)(data, function (_) {
	      return _.works.edges;
	    });
	  };
	
	  _class.prototype.getWorks = function getWorks() {
	    var category = this.state.category;
	
	    var works = this.getData();
	
	    return works && works.filter(function (_ref) {
	      var work = _ref.work;
	      return category ? !work.featured && work.category.includes(category) : !work.featured;
	    });
	  };
	
	  _class.prototype.getFeaturedWorks = function getFeaturedWorks() {
	    var works = this.getData();
	    return works && works.filter(function (_ref2) {
	      var work = _ref2.work;
	      return work.featured;
	    });
	  };
	
	  _class.prototype.render = function render() {
	    var category = this.state.category;
	
	
	    return _react2.default.createElement(
	      _shared.ContentWrapper,
	      null,
	      _react2.default.createElement(_Head2.default, _extends({}, _constants.META.works, {
	        image: _constants.META.common.image
	      })),
	      _react2.default.createElement(_WorksListSection2.default, {
	        works: this.getWorks(),
	        category: category,
	        setCategory: this.setCategory
	      })
	    );
	  };
	
	  return _class;
	}(_react.Component);
	
	exports.default = _class;
	var worksQuery = exports.worksQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-works-js-022e810b41a68eca4db7.js